"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var VIEWS = constants_1.default.VIEWS;
var global_error_1 = require("./common/global-error");
var extend_session_view_1 = require("./common/session/extend-session.view");
var placeholder_view_1 = require("./containers/placeholder.view");
var placeholder_view_2 = require("./containers/placeholder.view");
var placeholder_view_3 = require("./containers/placeholder.view");
var cookies_view_1 = require("./containers/cookies/cookies.view");
var update_passport_view_1 = require("./containers/account/update-passport.view");
var update_passport_success_view_1 = require("./containers/account/update-passport-success.view");
var delete_passport_view_1 = require("./containers/account/delete-passport.view");
var delete_passport_success_view_1 = require("./containers/account/delete-passport-success.view");
var viewMap = {};
// Global views
viewMap[VIEWS.GLOBAL_ERROR] = { view: global_error_1.default };
viewMap[VIEWS.EXTEND_SESSION] = { view: extend_session_view_1.default, isCloseXHidden: true };
viewMap[VIEWS.EMAILS.ADD] = { view: placeholder_view_1.default, isCloseXHidden: false };
viewMap[VIEWS.EMAILS.EDIT] = { view: placeholder_view_2.default, isCloseXHidden: false };
viewMap[VIEWS.UPDATE_PASSPORT] = { view: update_passport_view_1.default, isCloseXHidden: false };
viewMap[VIEWS.UPDATE_PASSPORT_SUCCESS] = { view: update_passport_success_view_1.default, isCloseXHidden: false };
viewMap[VIEWS.DELETE_PASSPORT] = { view: delete_passport_view_1.default, isCloseXHidden: false };
viewMap[VIEWS.DELETE_PASSPORT_SUCCESS] = { view: delete_passport_success_view_1.default, isCloseXHidden: false };
viewMap[VIEWS.NOTIFICATIONS] = { view: placeholder_view_3.default, isCloseXHidden: false };
viewMap[VIEWS.COOKIES] = { view: cookies_view_1.default, isCloseXHidden: true };
exports.default = viewMap;
